import { Animated, PanResponder } from 'react-native';
export var getPanResponder = (pan, minDistanceToCloseRatio, currentHeight, setModalVisibility) => {
  return PanResponder.create({
    onStartShouldSetPanResponder: () => {
      return true;
    },
    onMoveShouldSetPanResponder: (_e, gestureState) => {
      return gestureState.dy > 6;
    },
    onPanResponderMove: (e, gestureState) => {
      if (gestureState.dy > 0) {
        Animated.event([null, {
          dy: pan === null || pan === void 0 ? void 0 : pan.y
        }], {
          useNativeDriver: false
        })(e, gestureState);
      }
    },
    onPanResponderRelease: (_e, gestureState) => {
      var distanceToClose = currentHeight * minDistanceToCloseRatio;
      if (gestureState.dy > distanceToClose || gestureState.vy > 0.5) {
        setModalVisibility === null || setModalVisibility === void 0 ? void 0 : setModalVisibility(false, 'swipe', true);
      } else {
        Animated.spring(pan, {
          toValue: {
            x: 0,
            y: 0
          },
          useNativeDriver: true
        }).start();
      }
    }
  });
};
export var openWithAnimation = (pan, animationDuration, animationCompleteCallback) => {
  Animated.timing(pan, {
    toValue: {
      x: 0,
      y: 0
    },
    duration: animationDuration || 400,
    useNativeDriver: true
  }).start(() => {
    animationCompleteCallback === null || animationCompleteCallback === void 0 ? void 0 : animationCompleteCallback();
  });
};
export var closeWithAnimation = (pan, animationDuration, currentHeight, animationCompleteCallback) => {
  Animated.timing(pan, {
    toValue: {
      x: 0,
      y: currentHeight
    },
    duration: animationDuration || 400,
    useNativeDriver: true
  }).start(() => {
    animationCompleteCallback === null || animationCompleteCallback === void 0 ? void 0 : animationCompleteCallback();
  });
};
export var fetchTimeSpent = (endTime, startTime, isTimeInMiliSeconds) => {
  var getTime = endTime - startTime;
  if (isTimeInMiliSeconds) return (getTime || 0).toString();
  return (Math.ceil(getTime / 1000) || 0).toString();
};